import { render } from "./BaseTooltip.vue?vue&type=template&id=c4dee1c2&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=c4dee1c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4dee1c2"]])

export default __exports__